import { defineComponent, h } from 'vue';
import { QSelect, QIcon, QTooltip } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-select-dsgn',
    components: {
        QSelect,
        QIcon,
        QTooltip,
    },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const description = this.schema.description;
        const options = [];
        const schema = this.schema;
        const enums = schema.enum || schema.titleMap;
        if (Array.isArray(enums)) {
            for (var i = 0; i < enums.length; i++) {
                const item = enums[i];
                if (item && typeof item === 'object')
                    options.push({ label: item.name, value: item.value });
                else
                    options.push({ label: item, value: item });
            }
        }
        const modelValue = this.cmodel?.[this.schemakey];

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ xmarginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QSelect
                    outlined
                    dense
                    label={this.name}
                    hint={description ?? ''}
                    options={options}
                    modelValue={modelValue}
                    option-label="label"
                    option-value="value"
                    emit-value
                    map-options
                    style={{ width: '100%' }}
                >
                </QSelect>
            </div>
        );
    }
});